// Whether the chat panel is showing. The React bubble keeps this as component
// state and renders the panel itself; here the pill (toggle button) and the
// transcript panel are separate modules, so they share this one object.
/** id of the chat panel, referenced by the toggle's aria-controls. Ids are
 *  scoped to the widget's shadow root, so a constant is enough. */
export const CHAT_PANEL_ID = "moss-chat-panel";

export interface ChatState {
  readonly open: boolean;
  setOpen(open: boolean): void;
  toggle(): void;
  subscribe(fn: (open: boolean) => void): () => void;
}

export function createChatState(): ChatState {
  let open = false;
  const listeners = new Set<(open: boolean) => void>();
  const state: ChatState = {
    get open() {
      return open;
    },
    setOpen(next) {
      if (next === open) return;
      open = next;
      for (const fn of listeners) fn(open);
    },
    toggle() {
      state.setOpen(!open);
    },
    subscribe(fn) {
      listeners.add(fn);
      return () => {
        listeners.delete(fn);
      };
    },
  };
  return state;
}
